export const ANALYTICS_CLICK_BELL_SUBSCRIBE =
  'SEARCH/ANALYTICS_CLICK_BELL_SUBSCRIBE';
